import * as yup from "yup";

// Yup schema for field validations
export const MakePaymentSchema = yup.object().shape({
  billingAddress: yup.string().required("Required"),
  billingCity: yup.string().required("Required"),
  billingCountry: yup.string().required("Required"),
  billingEmail: yup.string().required("Required"),
  billingFirstName: yup.string().required("Required"),
  billingLastName: yup.string().required("Required"),
  billingState: yup.string().required("Required"),
  billingZip: yup.string().required("Required"),
  otherAmount: yup.number().when("otherAmountCheck", {
    is: true,
    then: yup.number().required().min(0.01, "Must be at least 0.01"),
  }),
  agentTip: yup.number().notRequired(),
  termsCheck: yup.bool().oneOf([true], "You must accept the Terms and Conditions")
});

export type MakePaymentFormData = yup.InferType<typeof MakePaymentSchema>;

export const MakePaymentSchemaDefaultValues: MakePaymentFormData = {
  billingAddress: "",
  billingCity: "",
  billingCountry: "",
  billingEmail: "",
  billingFirstName: "",
  billingLastName: "",
  billingState: "",
  billingZip: "",
  otherAmount: 0.0,
  agentTip: 0.0,
  termsCheck: false,
};